import { render, staticRenderFns } from "./fireFightingInfo.vue?vue&type=template&id=0b12b410"
import script from "./fireFightingInfo.vue?vue&type=script&lang=js"
export * from "./fireFightingInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b12b410')) {
      api.createRecord('0b12b410', component.options)
    } else {
      api.reload('0b12b410', component.options)
    }
    module.hot.accept("./fireFightingInfo.vue?vue&type=template&id=0b12b410", function () {
      api.rerender('0b12b410', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/fft/fireFightingInfo.vue"
export default component.exports